<template>
  <div>
    <div class="anm22-calendar-headmenu" style="padding:13px 8px 13px 8px;">
      <div class>
        <b>
          <span
            class="anm22-calendar-change-month-button prev"
            style="left:4px;"
            @click="prevWeek()"
            >&lt;</span
          >
          <span
            class="anm22-calendar-change-month-button succ"
            style="left:30px;"
            @click="nextWeek()"
            >&gt;</span
          >
          <span class="anm22-calendar-change-week-month">{{
            week.format("MMMM YY").toUpperCase()
          }}</span>
        </b>
      </div>
      <img
        :src="$anm22.icons.getWorldIcon('menuAvailability')"
        @click="$emit('searchEvent')"
        :title="$anm22.strLang(lang, 'Search', 'Cerca')"
        class="filter"
        style="right:45px;cursor:pointer;"
      />

      <span
        style="cursor:pointer; right:114px;"
        @click="newEvent(now)"
        class="newEventButton"
      >
        <div>
          <span class="wg-xs-none wg-sm- text">{{
            $anm22.strLang(lang, "New Event", "Nuovo Evento")
          }}</span>
          <img :src="$anm22.icons.getWorldIcon('addGreen')" />
        </div>
      </span>
      <img
        @click="changeView()"
        :class="['changeCalendarViewMode', loadEvent ? 'block' : '']"
        :title="$anm22.strLang(lang, 'Change view', 'Cambia visualizzazione')"
        :src="$anm22.icons.getWorldIcon('viewLastEvents')"
        style="opacity:0.46;cursor:pointer;right:15px;"
      />
      <template v-if="currentW == 'my'">
        <div
          class="my-project-icon work"
          style="cursor:pointer;position:absolute; top: 6px; right: 77px;"
          :title="$anm22.strLang(lang, 'My events', 'I miei eventi')"
          @click="$emit('showWorks')"
        >
          {{ user.name.substring(0, 1) }}
        </div>
      </template>
      <template v-else>
        <div class="anm22-calendar-round work">
          <img
            style="cursor:pointer;position:absolute;top: 6px; right: 77px;width:32px;height:32px;border-radius:16px;"
            :src="
              $anm22.getObjIcon(
                $store.getters['works/get'](currentW),
                'workDefault'
              )
            "
            :title="workCurrent ? workCurrent.name : undefined"
            @click="$emit('showWorks')"
          />
        </div>
      </template>
      <template v-if="box == false">
        <span
          class="anm22-calendar-tutorial-changeWork workBox"
          style="width:200px;height:50px;right:72px;"
        >
          {{
            $anm22.strLang(
              lang,
              "To switch the calendar and move to company ones click here.",
              " Per cambiare il calendario e passare a quelli aziendali clicca qui."
            )
          }}
          <div class="arrowup"></div>
          <div class="close" @click="$emit('close')">X</div>
        </span>
      </template>
    </div>

    <div class="clear-fix"></div>
    <div class>
      <div class>
        <div class="wg-row">
          <span class="anm22_wb_login_pagebody_conteiner">
            <b>{{ $anm22.strLang(lang, "from", "dal") }}</b>
            {{ weekTxt[0].start.format("DD-MM-YYYY").toUpperCase() }}
            <b>{{ $anm22.strLang(lang, "to", "al") }}</b>
            {{ weekTxt[0].end.format("DD-MM-YYYY").toUpperCase() }}
          </span>
        </div>
        <template
          v-if="
            calendar.reduce((res, el) => res || el.details.length > 0, false)
          "
        >
          <div
            v-for="(element, index) in calendar"
            :key="index"
            @click="newEvent(element.days)"
          >
            <span
              v-for="(event, index) in element.details"
              :key="'event-' + index"
            >
              <div
                @click.stop="$emit('selectEvent', event)"
                :class="[
                  'anm22_wb_login_pagebody_conteiner',
                  'anm22-calendar-event-wrapper',
                  event.type == 5 ? 'reminder' : '',
                ]"
              >
                <b>{{ event.name }}</b>
                <br />
                <small v-if="event.type === 5">
                  <b>{{ $anm22.strLang(lang, "Time:", "Ora:") }}</b>
                  {{
                    $moment
                      .unix(event.startTimestamp)
                      .tz(selectedTimezone)
                      .format("DD-MM-YYYY HH:mm")
                  }}
                </small>
                <small v-else>
                  <b>{{ $anm22.strLang(lang, "Start:", "Inizio:") }}</b>
                  {{
                    $moment
                      .unix(event.startTimestamp)
                      .tz(selectedTimezone)
                      .format("DD-MM-YYYY HH:mm")
                  }}
                  <br />
                  <b>{{ $anm22.strLang(lang, "End:", "Fine:") }}</b>
                  {{
                    $moment.unix(event.endTimestamp).format("DD-MM-YYYY HH:mm")
                  }}
                </small>
                <hr />
                <span style="float:right">
                  <small>
                    <b>{{
                      $anm22.strLang(lang, "Participants:", "Partecipanti:")
                    }}</b>
                  </small>
                  <template
                    v-for="(obj, index) in invitesWithUser(event).filter(
                      (obj) =>
                        obj.invite.status == 0 ||
                        obj.invite.status == 1 ||
                        obj.invite.status == 3
                    )"
                  >
                    <div
                      class="anm22-calendar-icon-inline anm22-calendar-round"
                      style="width:22px;height:22px;"
                      :key="event.idWorldInvite + '-invite-' + index"
                    >
                      <world-object-icon
                        :type="'user'"
                        :obj="obj.user"
                        :isImg="true"
                      ></world-object-icon>
                    </div>
                  </template>
                  <!-- <img
                    v-for="(obj,index) in invitesWithUser(event).filter(obj => obj.invite.status == 0 || obj.invite.status == 1 || obj.invite.status == 3)"
                    :key="event.idWorldInvite+'-invite-'+index"
                    :src="$anm22.getObjIcon(obj.user, 'userDefault')"
                    class="anm22-calendar-icon-inline anm22-calendar-round event-img"
                    :title="obj.user.name + ' ' + obj.user.surname"
                  /> -->
                </span>
                <br />
              </div>
            </span>
          </div>
        </template>
        <template v-else>
          <div
            class="anm22_wb_login_pagebody_conteiner anm22-calendar-event-wrapper"
          >
            <div class="com-anm22-app-text-l">
              {{
                $anm22.strLang(
                  lang,
                  "No event to display",
                  " Nessun evento da visualizzare in questo intervallo di date"
                )
              }}
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import EventView from "../components/EventView.vue";

export default {
  props: {
    selectedTimezone: [String],
    now: Object,
    events: Array,
    available: Boolean,
    workAvailable: Boolean,
    box: [Boolean, String],
    loadEvent: Boolean,
    currentW: [Number, String],
    currentTime: [Number],
    getMyEvents: [Function],
    getWorkEvents: [Function],
  },
  data() {
    return {
      meseCorrente: this.$moment().format("MMMM"),
      dataCorrente: this.$moment()
        .format("ll")
        .substring(0, 6),
      weekOffset: 0,
      red: "red",
      green: "green",
      dataMeet: "",
      name: "Events",
      noResults: false,
    };
  },
  components: {
    EventView,
  },

  computed: {
    ...mapState({
      windowWidth: (state) => state.windowWidth,
      user: (state) => state.auth.user,
      lang: (state) => state.lang,
    }),

    places() {
      return this.$store.getters["contactPlaces/getAll"];
    },

    employments() {
      return this.$store.getters["employments/getAll"];
    },
    work() {
      return this.$store.getters["works/getAll"];
    },

    users() {
      return this.$store.getters["users/getAll"];
    },
    workCurrent() {
      return this.$store.getters["works/get"](this.currentW);
    },
    week() {
      //console.log(this.monthOffset);
      return this.now.clone().add(this.weekOffset, "weeks");
    },
    newCurrentData() {
      return this.now.clone().add(this.weekOffset, "weeks");
    },
    newCurrentTime() {
      let a = this.newCurrentData.unix();
      return a;
    },
    calendar() {
      let result = [];
      const startDay = this.week.clone().startOf("week");
      const endDay = this.week.clone().endOf("week");
      let date = startDay.clone().subtract(1, "day");
      while (date.isBefore(endDay, "day")) {
        let calData = date.add(1, "day").clone();
        let detailsTxt = [];
        let detailsCreator = String;
        this.events.forEach((element) => {
          let title = element.name;
          let idWorldEvent = element.idWorldEvent;
          let startTimestamp = element.startTimestamp;
          let endTimestamp = element.endTimestamp;
          let place = element.place;
          let startEvents = this.timestampToTimezone(startTimestamp);
          let endEvents = this.timestampToTimezone(endTimestamp);
          // let startEvents = this.$moment.unix(startTimestamp);
          // let endEvents = this.$moment.unix(endTimestamp);
          if (
            calData.isBetween(startEvents, endEvents - 1, "day", []) &&
            element.type !== 8
          ) {
            detailsTxt.push(element);
          }
        }),
          result.push({
            days: calData,
            details: detailsTxt.sort(
              (a, b) => a.startTimestamp - b.startTimestamp
            ),
          });
        //console.log(this.noResults);
      }

      return result;
    },
    weekTxt() {
      let result = [];
      const startDay = this.week.clone().startOf("week");
      let startWeek = startDay.clone().subtract(1, "hour");
      const endWeek = this.week.clone().endOf("week");
      result.push({
        start: startWeek,
        end: endWeek,
      });
      return result;
    },
  },

  methods: {
    newEvent(date) {
      if (!date) {
        this.$emit("newEvent", this.$moment());
      } else {
        this.$emit(
          "newEvent",
          date
            .clone()
            .set({
              h: this.$moment().format("HH"),
              m: this.$moment().format("mm"),
            })
        );
      }
    },
    timestampToTimezone(ts) {
      return this.$moment.unix(ts).tz(this.selectedTimezone);
    },
    timestampToDate(ts) {
      const moment = this.timestampToTimezone(ts);
      return this.$moment(
        moment.format("YYYY") +
          "-" +
          moment.format("MM") +
          "-" +
          moment.format("DD")
      );
    },
    invitesWithUser(event) {
      return this.$store.getters["invites/getByEvent"](event.idWorldEvent)
        .map((i) => {
          return {
            invite: i,
            user: this.$store.getters["users/get"](i.user),
          };
        })
        .filter((invite) => invite.user);
    },
    prevWeek() {
      this.weekOffset--;
      this.$parent.currentTime = this.newCurrentTime;
      this.currentW === "my" ? this.getMyEvents() : this.getWorkEvents();
    },
    nextWeek() {
      this.weekOffset++;
      this.$parent.currentTime = this.newCurrentTime;
      this.currentW === "my" ? this.getMyEvents() : this.getWorkEvents();
    },
    changeView() {
      this.$parent.currentTime = this.$moment().unix();
      this.$parent.loadEvent = true;
      this.currentW === "my" ? this.getMyEvents() : this.getWorkEvents();
      this.$emit("changeView", "MonthView");
    },
  },
};
</script>

<style lang="scss" scoped>
.contMenu {
  padding: 0;
  list-style: none;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 1%;
  float: right;
  vertical-align: middle;
}
.reminder {
  background-color: #666;
  color: white;
  border-color: #444;
  &:hover {
    background-color: #888;
    border-color: #666;
  }
}
@media screen and (max-height: 300px) {
  .anm22-calendar-headmenu {
    height: 46px;
  }

  .anm22-calendar-headmenu .newEventButton {
    top: 13px;
  }

  .anm22-calendar-headmenu .filter {
    top: 8px;
  }
  .anm22-calendar-headmenu .changeCalendarViewMode {
    top: 11px;
  }
}
// @media (max-width: 800px){
//   .anm22-calendar-change-week-month {
//     margin-left:50px !important;
//   }
// }

.week-text {
  font-size: 2.9em;
  color: #a8b2b9;
}

.toolbar {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
}

.toggle {
  display: grid;
  grid-template-columns: 1fr 1fr;

  text-align: center;
  font-size: 0.9em;
}
.toggle__option {
  padding: 16px;
  border: 1px solid #e1e1e1;
  border-radius: 8px;
  text-transform: capitalize;
  cursor: pointer;
}
.toggle__option:first-child {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.anm22-calendar-change-month-button {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  width: 24px;
  height: 24px;
  margin: 0;
  border-radius: 15px;
  text-align: center;
  cursor: pointer;
  display: inline-block;
  position: absolute;
  top: 11px;
  line-height: 1;
  padding: 2px 0 0 0;
}
.anm22-calendar-headmenu-custom {
  padding: 13px 8px 13px 0px;
  position: relative;
  height: 46px;
  box-sizing: border-box;
  background-color: #fafafa;
  line-height: 1;
  font-size: 18px;
}
.toggle__option:last-child {
  border-left: 0;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.toggle__option--selected {
  border-color: white;
  background-color: white;
  color: var(--red);
  font-weight: 500;
  box-shadow: 1px 2px 30px -5px var(--red);
}
.my-project-icon {
  display: inline-block;
  background-color: #00af87;
  color: #fff;
  padding-top: 7px;
  line-height: 1.1;
  box-sizing: border-box;
  text-align: center;
  overflow: hidden;
  border-radius: 30px;
  vertical-align: middle;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.work {
  width: 32px;
  height: 32px;
  border-radius: 16px;
}

.monthBar {
  width: 100%;
  text-align: center;
  display: flex;
  margin-top: 10px;
  display: inline-block;
}

.day-of-week {
  width: calc(100% / 7);
  justify-content: center;
}

.wg-row {
  height: 50px;
  text-align: center;
}

.centered {
  position: relative;
  align-content: center;
  margin-top: 15px;
}
.day-block {
  height: 100%;
  flex-direction: column;
  flex-wrap: nowrap;
  padding: 0 2px;
  cursor: pointer;
  &.other-month {
    opacity: 0.4;
  }
  &:hover {
    background-color: #eee;
  }
}
.day-projects-div {
  height: 100%;
  & div {
    height: calc(100% / 6);
    padding: 1px 2px;
  }
}
.project-label {
  flex-wrap: nowrap;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  border-radius: 2px;
  background-color: #fff;
}

.current_momth {
  font-family: Montserrat;
  font-weight: 100;
  color: #a8b2b9;
}

.toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}
.workBox {
  position: absolute;
  top: 108px;
  right: 20px;
  padding: 4px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 40px;
  height: 40px;
  border-radius: 3px;
  background-color: white;
  -webkit-box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);
  color: black;
  line-height: 1;
  font-size: 14px;
  text-align: left;
  font-weight: 400;
}
.close {
  color: #aaa;
  float: right;
  font-size: 14px;
  margin-top: -27px;
  margin-right: -5px;
  font-weight: bold;
  cursor: pointer;
}
.block {
  pointer-events: none;
}
.arrowup {
  width: 0px;
  height: 0px;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid #fff;
  position: absolute;
  right: 8px;
  top: -10px;
}

.calendar__week,
.calendar__header {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
}
.calendar__week {
  grid-auto-rows: 100px;
  text-align: right;
}

.calendar__header {
  grid-auto-rows: 50px;
  align-items: center;
  text-align: center;
}

.calendar__day {
  padding: 16px;
}

.calendar {
  background-color: white;
  //border: 1px solid #e1e1e1;
  height: 650px;
}
@media screen and (max-width: 779px) {
  .anm22-calendar-change-week-month {
    margin-left: 50px;
  }
}
.calendar__header > div {
  text-transform: uppercase;
  font-size: 0.8em;
  font-weight: bold;
}

.calendar__day {
  border-right: 1px solid #e1e1e1;
  border-top: 1px solid #e1e1e1;
  height: 580px;
}

.calendar__day:last-child {
  border-right: 0;
}

.events {
  padding: 1px;
  margin: 2px;
  width: 100%;
  background-color: #dddddd;
  border-radius: 5px;
  cursor: pointer;
  //color: red;
}
.events:hover {
  background-color: #fff;
  border-radius: 3px;
  border-color: #a8b2b9;
  color: #000000;
}
@media (max-width: 290px) {
  .newEventButton {
    display: none;
  }
}
.flex-container {
  padding: 0;
  margin: 0;
  list-style: none;
  display: flex;
  align-items: center;
  justify-content: center;
}

.flex-item {
  background: darkgray;
  padding: 5px;
  width: 250px;
  margin: 15px;
  line-height: 25px;
  color: white;
  font-weight: bold;
  font-size: 1em;
  text-align: center;
  cursor: pointer;
}

.anm22_wb_login_pagebody_conteiner {
  width: 600px;
  max-width: 73%;
  padding: 20px;
  margin: 0 auto;
  cursor: pointer;
  margin-bottom: 10px;
  margin-top: 10px;
}
</style>
